import { useRef } from 'react';
import { useGridLayout } from '../hooks/useGridLayout';
import './NumberGrid.css';

interface NumberGridProps {
  numbers: number[];
  playedNumbers: number[];
  variant: 'tv' | 'compact';
  disabled?: boolean;
  onSelect?: (number: number) => void;
}

/** Сетка номеров: квадратная на ТВ или компактная на пульте. */
export const NumberGrid = ({
  numbers,
  playedNumbers,
  variant,
  disabled = false,
  onSelect,
}: NumberGridProps) => {
  const stageRef = useRef<HTMLDivElement>(null);
  const layout = useGridLayout(numbers.length, stageRef);
  const played = new Set(playedNumbers);

  if (numbers.length === 0) {
    return (
      <div className="number-grid-empty">
        <p>Загрузите пакет игры для начала</p>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="number-grid number-grid-compact">
        <div className="number-grid-container number-grid-container-compact">
          {numbers.map((number) => {
            const isPlayed = played.has(number);
            const canClick = !disabled && !isPlayed && !!onSelect;
            return (
              <button
                key={number}
                type="button"
                className={`number-cell ${isPlayed ? 'played' : ''} ${canClick ? 'clickable' : ''}`}
                disabled={!canClick}
                onClick={() => canClick && onSelect(number)}
              >
                {number}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="number-grid number-grid-tv">
      <div ref={stageRef} className="number-grid-stage">
        <div
          className="number-grid-container"
          style={{
            gridTemplateColumns: `repeat(${layout.columns}, ${layout.cellSize}px)`,
            gridAutoRows: `${layout.cellSize}px`,
            gap: layout.gap,
            fontSize: `${Math.max(14, Math.floor(layout.cellSize * 0.38))}px`,
          }}
        >
          {numbers.map((number) => {
            const isPlayed = played.has(number);
            return (
              <div
                key={number}
                className={`number-cell ${isPlayed ? 'played' : ''}`}
              >
                {number}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
